import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { InventoryProvider } from '@/context/InventoryContext';

// Layout
import { MainLayout } from '@/components/layout/MainLayout';

// Pages
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { ProductsPage } from '@/pages/ProductsPage';
import { InventoryPage } from '@/pages/InventoryPage';
import { ProductionPage } from '@/pages/ProductionPage';
import { ProcurementPage } from '@/pages/ProcurementPage';
import { GanttPage } from '@/pages/GanttPage';
import { QualityPage } from '@/pages/QualityPage';
import { CashflowPage } from '@/pages/CashflowPage';
import { AdminPage } from '@/pages/AdminPage';
import { UserManualPage } from '@/pages/UserManualPage';

// Protected route wrapper
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

// Admin-only route wrapper
function AdminRoute({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((state) => state.user);

  if (user?.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <InventoryProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="products/*" element={<ProductsPage />} />
          <Route path="inventory/*" element={<InventoryPage />} />
          <Route path="work-order/*" element={<ProductionPage />} />
          <Route path="procurement/*" element={<ProcurementPage />} />
          <Route path="gantt" element={<GanttPage />} />
          <Route path="quality/*" element={<QualityPage />} />
          <Route path="cashflow" element={<CashflowPage />} />
          <Route path="user-manual" element={<UserManualPage />} />
          <Route
            path="admin"
            element={
              <AdminRoute>
                <AdminPage />
              </AdminRoute>
            }
          />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </InventoryProvider>
  );
}
